import utilMixin from "../../mixins/common/utilMixin";
import { ordersCollection } from "@/collections/orders";

let menuGroupItem = window.localStorage.getItem("menuGroupItem");

const state = {
  orders: [],
  orderHistory: [],
  orderHistoryTotals: 0,
  myOrderQuantity: 0,
  activesQR: [],
  tableQR: utilMixin.tableFromLocalStorage(),
  adminTableQR: utilMixin.adminTableFromLocalStorage(),
  menuGroupItem: menuGroupItem ? JSON.parse(menuGroupItem) : []
};

const mutations = {
  setoOderHistoryTotals(state, val) {
    state.orderHistoryTotals = val;
  },
  setOrderHistory(state, val) {
    state.orderHistory = val;
  },
  setMyOrderQuantity(state, val = null) {
    if (val !== null) {
      state.myOrderQuantity = val;
    } else {
      state.myOrderQuantity++;
    }
  },
  setOrders(state, orders) {
    state.orders = orders;
  },
  setActivesQR(state, val) {
    state.activesQR = val;
  },
  setTableQR(state, val) {
    window.localStorage.setItem("tableQR", val);
    state.tableQR = val;
  },
  setAdminTableQR(state, val) {
    window.localStorage.setItem("adminTableQR", val);
    state.adminTableQR = val;
  },
  saveMenuGroupData(state, payload) {
    state.menuGroupItem.push(payload.item);
    window.localStorage.setItem(
      "menuGroupItem",
      JSON.stringify(state.menuGroupItem)
    );
  }
};

const actions = {
  ordersHistoryByRangeOfDate({ commit }, rangeOfDates) {
    if (rangeOfDates.start.getTime() === rangeOfDates.end.getTime()) {
      ordersCollection
        .where("time", ">=", rangeOfDates.start)
        .get()
        .then(querySnapshot => {
          let result = [];
          querySnapshot.forEach(doc => {
            result.push(doc.data());
          });
          commit("setOrderHistory", result);
        })
        .catch(error => {
          // eslint-disable-next-line
          console.log("Error getting documents: ", error);
        });
    } else {
      ordersCollection
        .where("time", ">=", rangeOfDates.start)
        .where("time", "<=", rangeOfDates.end)
        .get()
        .then(querySnapshot => {
          let result = [];
          querySnapshot.forEach(doc => {
            result.push(doc.data());
          });
          commit("setOrderHistory", result);
        })
        .catch(error => {
          // eslint-disable-next-line
          console.log("Error getting documents: ", error);
        });
    }
  }
};

const getters = {
  myOrdersQuantity: state => {
    return state.myOrderQuantity;
  },
  getQR: state => qr => {
    return state.activesQR.find(
      item => item.table?.toLowerCase() === qr?.toLowerCase()
    );
  }
};

export default {
  state,
  mutations,
  actions,
  getters
};
